import type { ApolloQueryResult } from '@apollo/client';
import type { CompatibleLanguage } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Notice, Text, TextLinkButton } from 'braid-design-system';
import React from 'react';

import type { Exact } from 'src/types/graphql';

import translations from './.vocab';

interface TaxonomyOptionsErrorProps {
  refetch: (
    variables?: Partial<
      Exact<{
        languageCode: CompatibleLanguage;
      }>
    >,
  ) => Promise<ApolloQueryResult<any>>;
}

export const TaxonomyOptionsErrorAlert = ({
  refetch,
}: TaxonomyOptionsErrorProps) => {
  const { t } = useTranslations(translations);

  const onRetryClick = () => {
    refetch();
  };

  return (
    <Notice tone="critical">
      <Text>
        {t('Sorry, we have an issue on our end.')}
        &nbsp;
        {t('Try again later', {
          TextLinkButton: (v) => (
            <TextLinkButton
              data={{ automation: 'refetch-taxonomies' }}
              onClick={onRetryClick}
              hitArea="large"
            >
              {v}
            </TextLinkButton>
          ),
        })}
      </Text>
    </Notice>
  );
};
